import React from 'react';
import { LanguageService } from '../../services';
import { StoryblokLinkNode } from '../../services/navigation/types';

interface BreadcrumbProps {
  list: StoryblokLinkNode[]
}

const filterList = (
  link: StoryblokLinkNode,
  index: number,
  list: StoryblokLinkNode[],
): boolean => {
  const { real_path: url } = link;
  const { real_path: nextUrl } = list[index + 1] || {};

  /**
   * Filter out:
   * - Any locale specific root level folder (de,en,fr,pt,etc)
   * - Folder, but only on root level pages;
   * - Current page;
   */
  if ((LanguageService.getActiveLanguage() !== LanguageService.getDefaultLocale() && index <= 0)) {
    return false;
  }

  return (
    `${url}/` !== nextUrl
    && index < list.length - 1
  );
};

interface BreadcrumbLink extends StoryblokLinkNode {
  no_link?: boolean;
}

const renderLinks = (
  link: BreadcrumbLink,
  index: number,
): JSX.Element => {
  const { real_path: url, name } = link;

  return link.no_link ? <>{name}</>
    : <roche-generic-link
      key={index}
      type="breadcrumbs"
      target="_self"
      url={url}
      text={name}
      icon={index <= 0 ? undefined : 'chevron-right'}
      size="medium"
    >
    </roche-generic-link>;
};

export const RocheBreadcrumbs = ({ list }: BreadcrumbProps): JSX.Element => {
  const filteredList = list.filter(filterList);

  return filteredList.length <= 0
    ? null
    : (
      <roche-grid data-breadcrumbs no-padding>
        <roche-breadcrumbs>
          {filteredList.map(renderLinks)}
        </roche-breadcrumbs>
      </roche-grid>
    );
};
